import React from 'react';

// Verify input is number only
export function numberValidator(value) {
    const re = /^[0-9\b]+$/;
    return re.test(value);
}

export let professionalDesignationList = [
    "General practitioner",
    "Geriatrician",
    "Medical director",
    "Neurologist",
    "Nurse practitioner",
    "Office staff",
    "Pharmacist",
    "Psychiatrist",
    "Psychologist",
    "Physician's assistant",   
    "Registered nurse",
    "Other"
]

export let numberTypeList = [
    "DEA",
    "ME",
    "NPI"
    
]

export let specificRequestList = [
    "Other",
    "Prescription Coverage Information",
    "Product Information",
    "Samples"
]

export let diseaseStateTreatedList = [
    "Both",
    "Dementia-Related Psychosis",
    "Parkinson's Disease Psychosis"
]

export let preferredContactList = [
    "Email",
    "Mail",
    "Office Visit",
    "Telephone",
]

export let preferredMethodOfContact = [
    "Email",
    "In-person",
    "Phone"
   
]

export let dayToBeContacted = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday"
]

export let timeOfTheDay = [
    "Morning",
    "Afternoon",
    "Evening"
]

export let interestList = [

"Acadia Connect support program",
"Appropriate patients for NUPLAZID",
"Insurance coverage for NUPLAZID",
"NUPLAZID clinical data and safety information",
"Other"

]


export let interestList2 = [
   
    { label: "Acadia Connect™ support program", value: "Acadia Connect™ support program" },
    { label: "Insurance coverage for NUPLAZID ", value: "Insurance coverage for NUPLAZID" },
    { label: "NUPLAZID clinical data and safety information", value: "NUPLAZID clinical data and safety information" },
    { label: "Other", value: "Other"}
  ]
  
// Lists of all the states
export let stateList = {
  "AL" : "Alabama",
  "AK" : "Alaska",
  "AS" : "American Samoa",
  "AZ" : "Arizona",
  "AR" : "Arkansas",
  "CA" : "California",
  "CO" : "Colorado",
  "CT" : "Connecticut",
  "DE" : "Delaware",
  "DC" : "District of Columbia",
  "FL" : "Florida",
  "GA" : "Georgia",
  "GU" : "Guam",
  "HI" : "Hawaii",
  "ID" : "Idaho",
  "IL" : "Illinois",
  "IN" : "Indiana",
  "IA" : "Iowa",
  "KS" : "Kansas",
  "KY" : "Kentucky",
  "LA" : "Louisiana",
  "ME" : "Maine",
  "MD" : "Maryland",
  "MA" : "Massachusetts",
  "MI" : "Michigan",
  "MN" : "Minnesota",
  "MS" : "Mississippi",
  "MO" : "Missouri",
  "MT" : "Montana",
  "NC" : "North Carolina",
  "ND" : "North Dakota",
  "NE" : "Nebraska",
  "NJ" : "New Jersey",
  "NH" : "New Hampshire",
  "NM" : "New Mexico",
  "NV" : "Nevada",
  "NY" : "New York",
  "OH" : "Ohio",
  "OK" : "Oklahoma",
  "OR" : "Oregon",
  "PA" : "Pennsylvania",
  "PR" : "Puerto Rico",
  "RI" : "Rhode Island",
  "SC" : "South Carolina",
  "SD" : "South Dakota",
  "TN" : "Tennessee",
  "TX" : "Texas",
  "UT" : "Utah",
  "VT" : "Vermont",
  "VI" : "Virgin Islands",
  "VA" : "Virginia",
  "WA" : "Washington",
  "WV" : "West Virginia",
  "WI" : "Wisconsin",
  "WY" : "Wyoming"
}

  
export function textareaField({ input, meta, label=null, placeholder }) {
    return (
      <div className="form-group">
          <textarea 
            {...input}
            className={"form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + (meta.valid && meta.touched ? "valid" : "")}
            placeholder={placeholder}
          />
          {meta.error && meta.touched && meta.error }          
      </div>
    );
  }